"use client";

import Link from "next/link";
import Image from "next/image";

const footerLinks = [
  { label: "Services", href: "/services" },
  { label: "About", href: "/about" },
  { label: "Work", href: "/work" },
  { label: "Careers", href: "/careers" },
  { label: "Contact", href: "/contact" },
];

export default function Footer() {
  return (
    <footer className="border-t border-[#1a1a1a]/5 py-12 px-6 bg-[#fafafa] mt-auto">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <Image src="/logo.png" alt="Mapleton Hill" width={100} height={24} className="h-5 w-auto opacity-40" />
          <span className="text-sm text-[#1a1a1a]/70">
            © 2026 · Boulder, CO
          </span>
        </div>
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2">
          {footerLinks.map((item) => (
            <Link
              key={item.label}
              href={item.href}
              className="text-sm text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors"
            >
              {item.label}
            </Link>
          ))}
          <Link
            href="/privacy"
            className="text-sm text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors"
          >
            Privacy
          </Link>
          <button
            type="button"
            onClick={() => window.dispatchEvent(new Event("mh:open-privacy-choices"))}
            className="text-sm text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors"
          >
            Your Privacy Choices
          </button>
        </div>
      </div>
    </footer>
  );
}
